import { Outlet } from 'react-router-dom';
import { DataProvider } from '../DataContext'

const DataLayout = () => {

  return (
    <DataProvider>
      <Outlet />
    </DataProvider>
  );
};

export default DataLayout;